import SectionTitle from "./SectionTitle";
import { players } from "@/mocks/home";

const accentMap: Record<string, { bubble: string; check: string }> = {
  primary: { bubble: "bg-primary-100 text-primary-700", check: "text-primary-600" },
  accent: { bubble: "bg-accent-100 text-accent-700", check: "text-accent-600" },
  secondary: { bubble: "bg-secondary-100 text-secondary-800", check: "text-secondary-700" },
};

export default function Players() {
  return (
    <section id="players" className="bg-background-100 border-y border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="播放器推荐"
          title="不同设备，用对播放器省一半力气"
          desc="浏览器、专业播放器、手机 App、电视端各有擅长场景。对照选择，能避免大多数“格式不支持”的问题。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {players.map((p) => {
            const accent = accentMap[p.accent] ?? accentMap.primary;
            return (
              <article
                key={p.id}
                className="flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
              >
                <div className="flex items-center justify-between">
                  <span className={`w-12 h-12 rounded-lg flex items-center justify-center ${accent.bubble}`}>
                    <i className={`${p.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <span className="px-2 py-0.5 rounded-full bg-background-200 text-foreground-700 text-[11px] font-medium">
                    {p.tag}
                  </span>
                </div>

                <h3 className="mt-4 text-base font-semibold text-foreground-950">{p.name}</h3>
                <p className="mt-1 text-xs text-foreground-600">适合：{p.best}</p>

                <ul className="mt-4 space-y-2 flex-1">
                  {p.pros.map((pro) => (
                    <li key={pro} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className={`ri-check-line mt-0.5 ${accent.check}`} aria-hidden="true"></i>
                      <span>{pro}</span>
                    </li>
                  ))}
                  {p.cons.map((con) => (
                    <li key={con} className="flex items-start gap-2 text-sm text-foreground-500">
                      <i className="ri-subtract-line mt-0.5" aria-hidden="true"></i>
                      <span>{con}</span>
                    </li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>

        <div className="mt-6 rounded-lg bg-accent-50 border border-accent-200 p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
          <span className="w-10 h-10 shrink-0 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
            <i className="ri-lightbulb-line text-xl" aria-hidden="true"></i>
          </span>
          <p className="text-sm text-foreground-700 leading-relaxed">
            选择原则很简单：<strong className="text-foreground-950">只是想快速看一眼就用新版浏览器；下载到本地的文件格式不确定就用 VLC；手机和电视优先用对应平台的本地播放器。</strong>
            遇到无声或花屏时，先尝试在播放器里切换“解码方式”。
          </p>
        </div>
      </div>
    </section>
  );
}